module.exports = __webpack_public_path__ + "static/media/vn.28dbb9cb.svg";